
import respUtility from '@/mixins/respUtility';

export default {
  name: 'ProductInfoReviewsItemReviewer',
  mixins: [respUtility],
  props: {
    review: {
      type: Object,
    },
    isProductPage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isMobile() {
      return this.$device.isMobileOrTablet || this.isTouchDevice;
    },
    isBoutiquePage() {
      return this.$store.state.metaData?.addons?.head?.isBoutique || false;
    },
    starColor() {
      return this.isMobile ? this.$cp.primary_support_darker1 : this.$cp.primary_support;
    },
    starStyle() {
      return {
        fullStarColor: this.isBoutiquePage ? this.$cp.tertiary_specialMain : `${this.starColor}`,
        emptyStarColor: this.isBoutiquePage ? this.$cp.white : this.$cp.white,
        starWidth: 14,
        starHeight: 14,
      };
    },
  },
};
